import { render } from "./Id.vue?vue&type=template&id=7f1aed00"
import script from "./Id.vue?vue&type=script&lang=js"
export * from "./Id.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ab-front-library/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__